import { FC } from "react";
import { IconProps } from "./types";

export const VerticalAlignTop: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M5 5a.968.968 0 0 1-.713-.287A.968.968 0 0 1 4 4c0-.283.096-.52.287-.712A.968.968 0 0 1 5 3h14c.283 0 .52.096.712.288.192.191.288.429.288.712s-.096.52-.288.713A.968.968 0 0 1 19 5H5zm7 16a.968.968 0 0 1-.713-.288A.968.968 0 0 1 11 20v-9.2l-1.9 1.9a.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275.948.948 0 0 1-.275-.7c0-.283.092-.517.275-.7l3.6-3.6c.1-.1.208-.17.325-.213.117-.041.242-.062.375-.062s.258.02.375.063a.877.877 0 0 1 .325.212l3.6 3.6a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275L13 10.8V20c0 .283-.096.52-.287.712A.968.968 0 0 1 12 21z"
      fill={fill}
    />
  </svg>
);
